import { getTranslationMaterialFromStore } from "@/store/reducers/translationsMaterialsReducer";
import { store } from "@/index";

type Params = {
    material_external_id: string;
    material_title: string;
};

const translatedMaterialTitle = ({ material_external_id, material_title }: Params): string => {
    const material_translation = getTranslationMaterialFromStore(store.getState(), {
        external_id: material_external_id,
    });
    return material_translation || material_title;
};

export default translatedMaterialTitle;
